const ActionTypes = Object.freeze({
  INITIAL_DATA: 'INITIAL_DATA',
  REQUEST_DATA: 'REQUEST_DATA',
  RESPONSE_DATA: 'RESPONSE_DATA',
  SAVE_DATA: 'SAVE_DATA',
  TRIGGER_DATA: 'TRIGGER_DATA'
});

export default ActionTypes;
